if (!customElements.get('x-unboxing-videos')) {
  customElements.define('x-unboxing-videos', class extends HTMLElement {
    connectedCallback() {
      this.init = this.init || this.initSlider.bind(this);
      // Section 内的 defer 脚本可能先于全局 Swiper 执行，等依赖加载完再初始化。
      if (document.readyState === 'loading' || typeof Swiper === 'undefined') {
        document.addEventListener('DOMContentLoaded', this.init, { once: true });
      } else {
        this.init();
      }
    }

    initSlider() {
      if (!this.isConnected || this.slider || typeof Swiper === 'undefined') return;
      const track = this.querySelector('.x-unboxing-videos__track');
      if (!track) return;

      this.slider = new Swiper(track, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        slidesPerGroup: 1,
        watchOverflow: true,
        // 拖动结束时拦截点击，避免滑动手势触发现有的视频播放监听。
        preventClicks: true,
        preventClicksPropagation: true,
        navigation: {
          prevEl: this.querySelector('.x-unboxing-videos__prev'),
          nextEl: this.querySelector('.x-unboxing-videos__next'),
        },
        breakpoints: {
          769: { spaceBetween: 16 },
        },
      });

      this.resizeObserver = new ResizeObserver(() => this.updateAccordionHeight());
      this.resizeObserver.observe(track);
      this.updateAccordionHeight();
    }

    updateAccordionHeight() {
      const accordion = this.closest('.x-product-feature__item');
      if (!accordion || !accordion.classList.contains('x-product-feature__item--expand')) return;
      // 手风琴使用固定高度；断点切换和标题换行后需重新测量，避免裁切或残留空白。
      accordion.style.height = 'auto';
      accordion.style.height = accordion.scrollHeight + 'px';
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.init);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.slider) this.slider.destroy(true, true);
      this.slider = null;
    }
  });
}
